/**
 * Kill switch `updates.autoupdate` côté APK.
 *
 * La page le respectait déjà (useAutoUpdate), mais l'APK vérifie version.json seule au
 * démarrage puis toutes les 30 min (≥ 1.5.9.33) sans jamais le consulter : couper les
 * mises à jour depuis le back-office n'arrêtait pas un déploiement natif.
 *
 * À partir de 1.5.9.38 l'APK expose setAutoUpdateLocked(boolean), mémorisé : la
 * vérification native s'arrête tant que le verrou est posé. Versions précédentes : sans
 * effet (méthode absente).
 */

type LockableUpdater = { setAutoUpdateLocked?: (locked: boolean) => void };

/** @returns true si l'APK a reçu le verrou, false si la méthode n'existe pas. */
export function applyAutoUpdateLock(
  w: { VisionPOSUpdater?: LockableUpdater },
  locked: boolean,
): boolean {
  const updater = w.VisionPOSUpdater;
  if (typeof updater?.setAutoUpdateLocked !== 'function') return false;
  try {
    updater.setAutoUpdateLocked(locked);
    return true;
  } catch {
    return false;
  }
}
